// extracted by mini-css-extract-plugin
module.exports = {"sidebar-thumb-height-journal":"343","sidebarThumbHeightJournal":"343","journal":"_3jjLG"};